import React from 'react';
import icons from './icons';
const defaultPosition = {};

const BlinkingIcon = ({
  icon,
  size = 16,
  color,
  animationDuration = '2s',
  animationDelay = '',
  position: { top, left, right, bottom } = defaultPosition,
}) => {
  const IconComponent = icons[icon];

  return (
    <span
      className="ws-ui-blinking-icon"
      style={{ animationDuration, animationDelay, top, left, right, bottom }}
    >
      <IconComponent size={size} color={color} />
    </span>
  );
};

export default BlinkingIcon;
